import apiClient from 'api/apiClient';

export const getFolders = () => (
  apiClient.get('/v1/analytics/folders')
);

export const getLastRefreshTime = () => (
  apiClient.get('/v1/analytics/last_refresh_time')
);
